import {
  CreateCompanyLinkRequest,
  UpdateCompanyLinkRequest,
  checkAddCompanyLink,
  checkRemoveCompanyLink,
  checkUpdateCompanyLink,
} from '@beeboard/common';
import { defineStore } from 'pinia';
import { useCompanyLinkStore } from './companyLinkStore';

export const useCompanyLinkRulesStore = defineStore('companyLinkRulesStore', {
  actions: {
    validateCreateCompanyLinkRequest(payload: CreateCompanyLinkRequest) {
      const linkTitles = useCompanyLinkStore().companyLinks.map((l) => l.title);

      return checkAddCompanyLink(payload, linkTitles);
    },

    validateUpdateCompanyLinkRequest(
      payload: UpdateCompanyLinkRequest,
      linkId: string,
    ) {
      const linkTitles = useCompanyLinkStore()
        .companyLinks.filter((d) => d.id !== linkId)
        .map((l) => l.title);

      return checkUpdateCompanyLink(payload, linkTitles);
    },

    validateRemoveCompanyLinkRequest(linkId: string) {
      return checkRemoveCompanyLink(useCompanyLinkStore().companyLink(linkId));
    },
  },
});
